import { render, staticRenderFns } from "./SequenceMain.vue?vue&type=template&id=022e1f7c&scoped=true"
import script from "./SequenceMain.vue?vue&type=script&lang=ts"
export * from "./SequenceMain.vue?vue&type=script&lang=ts"
import style0 from "./SequenceMain.vue?vue&type=style&index=0&id=022e1f7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022e1f7c",
  null
  
)

export default component.exports